/**
 * WHICH KEY THE HINTS NAME — cosmetic, and only cosmetic.
 *
 * Every modifier shortcut here listens for ⌘ AND Ctrl, always. This says only
 * which of the two to PRINT, so a Mac at the dispensary bench and a Windows POS
 * each read the chip for the key actually under the operator's thumb.
 *
 * One copy, because two platform checks is how one of them ends up saying Ctrl
 * on a Mac.
 *
 * `navigator.platform` is deprecated and is still the only thing that answers
 * this honestly (`userAgentData` omits it on Safari), so both are consulted.
 * Guarded for the node environment the unit tests run in, where there is no
 * navigator at all.
 */
export const isMac: boolean =
  typeof navigator !== "undefined" &&
  // `platform` is deprecated and is still the only thing that answers this
  // honestly; its replacement omits it on Safari. Read once, cosmetically, and
  // nothing is ever gated on the answer.
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

/** The modifier key, as the operator's own keyboard prints it. */
export const MOD_KEY = isMac ? "⌘" : "Ctrl";

/** The platform's primary-action shortcut, printed: `⌘↵` · `Ctrl ↵`. */
export const MOD_ENTER = isMac ? "⌘↵" : "Ctrl ↵";

/** True where this event carries the platform's own modifier, either spelling. */
export function hasMod(e: Pick<KeyboardEvent, "metaKey" | "ctrlKey">): boolean {
  return e.metaKey || e.ctrlKey;
}
